module.exports = __webpack_public_path__ + "img/LATIN10_26.79b85270.jpg";